<template>
  <div class="cc-calendar">
    <calendarHeader :headOptions="headOptions" @handlePrevMonth='handlePrevMonth' @handlePrevYear='handlePrevYear' @handleNextMonth='handleNextMonth' @handleNextYear='handleNextYear' @handleToday='handleToday' />
    <ul class="calendar-week clear">
      <li v-for="(item, index) in calendarTitleArr" :key="index" class="week-item">{{item}}</li>
    </ul>
    <ul class="calendar-view clear">
      <li v-for="(item, index) in visibleCalendar" :key="index" class="date-view" :class="[
          {'month-class': !isCurrentMonth(item.date)},
        //   {todayBg: isCurrentDay(item.date)},
          {handleDay: item.clickDay}
        ]" @click="handleClickDay(item)">
        <span class="date-day" :style="dayStyle" :class="[{'opacity-class': !isCurrentMonth(item.date)},
            {todayBg: isCurrentDay(item.date)},
            ]">
          {{item.day}}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import '../assets/css/reset.min.css'
import calendarHeader from './canlendar-head.vue';
import * as utils from '../assets/js/utils.js';

export default {
  name: 'cc-calendar',
  componentName: 'cc-calendar',
  props: {
    options: Object
  },
  components: {
    calendarHeader
  },
  data () {
    let {
      year,
      month,
      day
    } = utils.getNewDate(new Date());
    return {
      headOptions: {
        type: this.options.type,
        style: this.options.headStyle,
        date: '',
      },
      calendarTitleArr: [
        '周一',
        '周二',
        '周三',
        '周四',
        '周五',
        '周六',
        '周日'
      ],
      time: {
        year,
        month,
        day
      },
      calendarList: []
    }
  },
  computed: {
    dayStyle: function () {
      return {
        textAlign: this.options.viewStyle.day,
      }
    },
    visibleCalendar () {
      let calendatArr = [];
      let {
        year,
        month,
        day
      } = utils.getNewDate(utils.getDate(this.time.year, this.time.month, 1));

      let currentFirstDay = utils.getDate(year, month, 1);

      // 获取当前月第一天星期几
      let weekDay = currentFirstDay.getDay();
      let startTime = currentFirstDay - (weekDay - 1) * 24 * 60 * 60 * 1000;

      let monthDayNum;
      if (weekDay == 5 || weekDay == 6) {
        monthDayNum = 42
      } else {
        monthDayNum = 35
      };

      for (let i = 0; i < monthDayNum; i++) {
        calendatArr.push({
          date: new Date(startTime + i * 24 * 60 * 60 * 1000),
          year: year,
          month: month + 1,
          day: new Date(startTime + i * 24 * 60 * 60 * 1000).getDate(),
          clickDay: false,
        })
      };

      this.headOptions.date = `${year}年${(month + 1).toString().padStart(2, 0)}月`;
      return calendatArr
    }
  },
  methods: {
    // 是否是当前月
    isCurrentMonth (date) {
      let {
        year: currentYear,
        month: currentMonth
      } = utils.getNewDate(utils.getDate(this.time.year, this.time.month, 1));
      let {
        year,
        month
      } = utils.getNewDate(date);
      return currentYear == year && currentMonth == month
    },
    // 是否是今天 
    isCurrentDay (date) {
      let {
        year: currentYear,
        month: currentMonth,
        day: currentDay
      } = utils.getNewDate(new Date());
      let {
        year,
        month,
        day
      } = utils.getNewDate(date);
      return currentYear == year && currentMonth == month && currentDay == day;
    },
    // 上一年
    handlePrevYear () {
      let prevYear = utils.getDate(this.time.year, this.time.month, 1);
      prevYear.setYear(prevYear.getFullYear() - 1);
      this.time = utils.getNewDate(prevYear);
      this.headOptions.date = `${this.time.year}年${(this.time.month + 1).toString().padStart(2, 0)}月`;
      this.$emit('handlePrevMonth');
    },
    // 上一个月
    handlePrevMonth () {
      let prevMonth = utils.getDate(this.time.year, this.time.month, 1);
      prevMonth.setMonth(prevMonth.getMonth() - 1);
      this.time = utils.getNewDate(prevMonth);
      this.headOptions.date = `${this.time.year}年${(this.time.month + 1).toString().padStart(2, 0)}月`;
      this.$emit('handlePrevMonth');
    },
    // 下一个月
    handleNextMonth () {
      let nextMonth = utils.getDate(this.time.year, this.time.month, 1);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      this.time = utils.getNewDate(nextMonth);
      this.headOptions.date = `${this.time.year}年${(1 + this.time.month).toString().padStart(2, 0)}月`;
      this.$emit('handleNextMonth');
    },
    // 下一年
    handleNextYear () {
      let nextYear = utils.getDate(this.time.year, this.time.month, 1);
      nextYear.setYear(nextYear.getFullYear() + 1);
      this.time = utils.getNewDate(nextYear);
      this.headOptions.date = `${this.time.year}年${(1 + this.time.month).toString().padStart(2, 0)}月`;
      this.$emit('handleNextMonth');
    },
    // 点击回到今天
    handleToday () {
      this.time = utils.getNewDate(new Date());
      this.returnDate();
      this.$emit('handleToday');
    },
    // 点击某一天
    handleClickDay (item) {
      this.$forceUpdate();
      this.$emit('handleClickDay', item);
      this.calendarList.map(x => {
        x.clickDay = false;
      });
      this.visibleCalendar.map(x => {
        x.clickDay = false;
      });
      this.$set(item, 'clickDay', true);
    }
  },
  created () {
    this.calendarList = this.visibleCalendar;
    this.calendarType = this.options.calendarType;
  }
}
</script>

<style lang="less">
.cc-calendar {
  width: 100%;
  height: 100%;
  background: #f9fafc;
  box-sizing: border-box;

  .calendar-week {
    width: 100%;
    height: 50px;
    line-height: 50px;
    // border: 1px solid #E4E7EA;
    border-right: none;
    background-color: #fff;

    .week-item {
      float: left;
      width: 14.285%;
      text-align: center;
      font-size: 14px;
      color: #424953;
      // border-right: 1px solid #E4E7EA;
      font-weight: 600;
    }
  }

  .calendar-view {
    width: 100%;
    // border-left: 1px solid #E4E7EA;

    li:nth-child(-n + 7) {
      background-color: rgba(245, 247, 250, 0.3);
    }

    li:nth-child(n + 14):nth-child(-n + 21) {
      background-color: rgba(245, 247, 250, 0.3);
    }

    li:nth-child(n + 28):nth-child(-n + 35) {
      background-color: rgba(245, 247, 250, 0.3);
    }

    li:nth-child(n + 8):nth-child(-n + 14) {
      background-color: #fff;
    }

    li:nth-child(n + 22):nth-child(-n + 28) {
      background-color: #fff;
    }

    .date-view {
      float: left;
      width: 14.285%;
      height: 50px;
      // border-right: 1px solid #E4E7EA;
      // border-bottom: 1px solid #E4E7EA;
      cursor: pointer;

      .date-day {
        padding: 8px 8px 0;
        display: block;
        width: 100%;
        font-size: 14px;
        color: #252a37;
        line-height: 36px;
      }

      .calendar-num {
        margin-top: 6px;
        display: block;
        width: 100%;
        text-align: center;
        font-size: 30px;
        color: #424953;
      }
    }

    .opacity-class {
      opacity: 0.3;
    }

    .month-class {
      color: rgba(194, 194, 210, 0.3);
    }

    .todayBg {
      // background: #FFFDEF;
      border: 1px solid #2c59c3;
      width: 33px !important;
      height: 32px !important;
      line-height: 15px !important;
      margin: 9px 30px !important;
      border-radius: 50%;
    }

    .handleDay {
      // background: #2061FF !important;
      display: flex;
      justify-content: center;
      align-items: center;

      .date-day {
        color: #fff !important;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #2c59c3;
        line-height: 15px;
        text-align: center;
      }

      .calendar-num {
        color: #fff !important;
      }
    }
  }
}
</style>
